
export default [
  {
    path: '/admin/eod',
    name: 'eod',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/eod')
  }
]
